import SitesModule from './index.vue';

// eslint-disable-next-line import/prefer-default-export
export const sitesRoutes = [
  {
    path: '/sites',
    component: SitesModule,
    meta: {
      requiresAuth: true,
    },
    children: [
      {
        path: '',
        name: 'Sites',
        component: () => import(/* webpackChunkName: "users" */ './pages/site-grid.vue'),
        meta: {
          /** Access to this route is managed on the server no need to specify in the meta */
        },
      },
      // {
      //   path: 'tiles',
      //   name: 'tilesview',
      //   component: () => import(/* webpackChunkName: "users" */ './pages/site-list.vue'),
      //   meta: {
      //     requiresAuth: true,
      //   },
      //   beforeEnter(to, from, next) {
      //     // TODO: validate if user admin
      //     console.log(to, from);
      //     next();
      //   },
      // },
      // {
      //   path: 'details/:id',
      //   name: 'SiteDetails',
      //   component: () => import(/* webpackChunkName: "users" */ './pages/site-details.vue'),
      //   meta: {
      //     requiresAuth: true,
      //   },
      //   beforeEnter(to, from, next) {
      //     // TODO: validate if user id matches logged user id if user is not admin
      //     console.log(to, from);
      //     next();
      //   },
      // },
    ],
  },
];
